1,2,3,5,6,20,21,22,23,24,25,30,31,32,33,34,35,36,40,41,42,43,50,51,52,53,54,55,56,57,58,60,70